module.exports = __webpack_public_path__ + "assets/videos/floorplan/floorplan-1970/0019.jpg?v=31faecff";